<template>
  <v-dialog v-model="showDateModal" width="290px" :disabled="disabled">
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        outlined
        v-model="savedDateValue"
        v-on="on"
        readonly
        :clearable="!disabled"
        hide-details="auto"
        prepend-icon="fal fa-calendar"
        :rules="rules"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectedDate"
      scrollable
      color="primary"
      :min="minDateValue"
      :max="maxDateValue"
      locale="pt"
    >
      <v-spacer></v-spacer>
      <v-btn text class="gray" @click="close">Cancel</v-btn>
      <v-btn text color="primary" @click="save">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import FormatterHelper from "@/scripts/helpers/formatter.helper";
export default {
  props: {
    label: String,
    value: null,
    minDate: null,
    maxDate: null,
    rules: Array,
    disabled: {
      type: Boolean,
      default: true
    },
    dateFormat: {
      type: String,
      default: "dd/MM/yyyy"
    }
  },
  data() {
    return {
      showDateModal: false,
      selectedDate: null,
      savedDate: null,
      datePickerFormat: "yyyy-MM-dd"
    };
  },
  mounted() {
    if (this.value) {
      this.savedDate = FormatterHelper.parseDate(this.value, this.dateFormat);
      this.selectedDate = FormatterHelper.formatDateWithPattern(
        this.value,
        this.datePickerFormat
      );
    }
  },
  computed: {
    minDateValue() {
      if (this.minDate) {
        return FormatterHelper.formatDateWithPattern(
          this.minDate,
          this.datePickerFormat
        );
      }
      return null;
    },
    maxDateValue() {
      if (this.maxDate) {
        return FormatterHelper.formatDateWithPattern(
          this.maxDate,
          this.datePickerFormat
        );
      }
      return null;
    },
    savedDateValue: {
      get() {
        if (this.savedDate) {
          return FormatterHelper.formatDateWithPattern(
            this.savedDate,
            this.dateFormat
          );
        }
        return null;
      },
      set(value) {
        if (this.disabled) return;
        this.selectedDate = value;
        this.save();
      }
    }
  },
  watch: {
    value() {
      if (!this.value) this.savedDateValue = this.value;
      else {
        if (this.value) {
          this.savedDate = FormatterHelper.parseDate(
            this.value,
            this.dateFormat
          );
          this.selectedDate = FormatterHelper.formatDateWithPattern(
            this.value,
            this.datePickerFormat
          );
        }
      }
    }
  },
  methods: {
    save() {
      if (this.disabled) return;
      if (this.selectedDate) {
        this.savedDate = FormatterHelper.parseDate(
          this.selectedDate,
          this.datePickerFormat
        );
      } else {
        this.savedDate = null;
      }
      this.showDateModal = false;
      this.$emit("input", this.savedDate);
    },
    close() {
      this.showDateModal = false;
      if (this.savedDate) {
        this.selectedDate = FormatterHelper.formatDateWithPattern(
          this.savedDate,
          this.datePickerFormat
        );
      } else {
        this.selectedDate = null;
      }
    }
  }
};
</script>